import { twMerge } from 'tailwind-merge';
import searchImg from '../../../common/images/revamp/icon/search.svg';
import useSearchHeader from './useSearchHeader';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import useNavigation from '../../../hook/useNavigation';

const SeachHeader = (props) => {
	const navigate = useNavigation();
	const { query, handleSearch, inputRef } = props;
	const { shadowHeader } = useSearchHeader();

	return (
		<div className={twMerge('px-4 py-3 sticky top-0 z-5 flex items-center justify-between gap-2.5 bg-white transition-all shadow-none', shadowHeader && 'shadow-[0px_0px_22px_0px_#0000001A]')}>
			<ArrowLeftIcon id='search_food_back' className={`h-8 w-8 transition-all duration-300 text-gray-900 p-1.5`} onClick={() => navigate.push('/')} />
			<div className='flex-auto flex items-center rounded-full border border-solid border-[var(--pin-ball)] p-2 gap-3'>
				<img src={searchImg} alt='search' />
				<input
					id='search_food_fill_query'
					ref={inputRef}
					placeholder='Mau cari makanan apa?'
					name='search'
					className='flex-auto w-full m-0 bg-transparent border-none outline-none'
					value={query}
					onChange={(event) => {
						handleSearch(event.target.value);
					}}
				/>
			</div>
		</div>
	);
};

export default SeachHeader;
